import './EpisodeList.scss'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'

import Loading from '../../components/Loading'
import OrderButtons from './OrderButtons'
import EpisodeListItem from './EpisodeListItem'

import { getTranslateValue } from '../../utils/locale'
import { EpisodeListItemFragment, EpisodesOrderTypes, Maybe } from '../../types/generated'

interface Props {
  loading: boolean
  called: boolean
  episodes: EpisodeListItemFragment[]
  visibleOrder: boolean
  selectedOrderKey: Maybe<EpisodesOrderTypes>
  episodeListRef: React.RefObject<HTMLUListElement>
  onOrderKeyChange: (key: EpisodesOrderTypes) => void
}

export default function EpisodeList({
  loading,
  called,
  episodes,
  visibleOrder,
  selectedOrderKey,
  episodeListRef,
  onOrderKeyChange,
}: Props) {
  const { t } = useTranslation()

  return (
    <div className="EpisodeList">
      {visibleOrder && <OrderButtons selectedOrderKey={selectedOrderKey} onClick={onOrderKeyChange} />}
      <ul ref={episodeListRef}>
        {episodes.map(episode => (
          <EpisodeListItem
            key={episode.id}
            title={getTranslateValue(episode, 'title')}
            imageUrl={episode.images?.thumbnail ?? ''}
            link={episode.link}
            synopsis={getTranslateValue(episode, 'synopsis')}
            videoDuration={episode.videoDuration}
            ccLanguages={episode.videoCcLanguages}
          />
        ))}
      </ul>
      {loading && <Loading visible size={40} />}
      {called && !loading && isEmpty(episodes) && (
        <div className="EpisodeList__noEpisodes">{t('program.noEpisodes')}</div>
      )}
    </div>
  )
}
